import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrintIcon from "@mui/icons-material/Print";
import ClearIcon from "@mui/icons-material/Clear";
import Logo from "../assets/Logo.png";
import moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Toolbar,
  Box,
  Divider,
  Tooltip,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import secureLocalStorage from "react-secure-storage";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Person2Icon from "@mui/icons-material/Person2";
import { clearAdvice } from "../actions/advice";
import { clearBranchAdvice } from "../actions/branchAdvice";
import FolderIcon from "@mui/icons-material/Folder";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Helmet } from "react-helmet-async";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { message, Popconfirm } from "antd";
import toast from "react-hot-toast";
function createData(name, history) {
  return { name, history };
}
function createBranchData(
  id,
  code,
  status,
  date,
  description,
  amount,
  submitted_by,
  branch,
  sanction_by,
  submitter_position,
  approved_by,
  approvers_position,
  amount_in_words,
  attached_file,
  filename
) {
  return {
    id,
    code,
    status,
    date,
    description,
    amount,
    submitted_by,
    branch,
    sanction_by,
    submitter_position,
    approved_by,
    approvers_position,
    amount_in_words,
    attached_file,
    filename,
  };
}

// BranchRow component
const handlePrint = (rowData) => {
  // Create a new window for printing
  const printWindow = window.open("", "_blank");
  // 1201.01 one thousand two hundred and one ghana cedis one ghana pesewa
  // 10003.
  // Create the HTML content to be printed
  const content = `
    <html>
      <head>
        <title>eAdvice</title>
        <style>
        body{
          font-size:20px;
        }
        .main {
          display: flex;
          flex-direction:column;
          justify-content: start;
          align-items: start;
          height: 75vh;
          margin: 0;
          position: relative;
          font-size:18px;
          margin: 0;
          
        }
        .sub-main {
          display: flex;
          flex-direction:column;
          justify-content: center;
          align-items: center;
          width: 100%;
          
        }
        .approve{
          display:flex;
          flex-direction: row;
          justify-content: space-between;

        }
        .watermark.top-left {
          top: 20px;
          left: 20px;
        }
        
        .watermark.bottom-right {
          bottom: 20px;
          right: 20px;
        }
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          opacity:0.3;
          transform: translate(-50%, -50%);
          font-size: 80px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.2);
          pointer-events: none;
          z-index: -1;
        }
        .amount{
          font-weight:bold;
        }
        table {
          border-collapse: collapse;
          width: 90%;
        }
        .employee_signature{
          margin-top: 30px;
        }
        th, td {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        
        th {
          background-color: #ccc;
        }
        .company{
          // margin-left:-70px;
          width: 90%;
        }
       
      
        .claim-code {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 90%;
          text-align: left;
          padding: 10px;
          background-color: #f1f1f1;
          font-weight: bold;
        }
        .sanctioned_by{
          margin-left: 10px;
        }
        .branch{
          margin-top: -10px;
        }
        .signature{
          width:49px;
          height:39px;
          margin-top: -30px;
        }
        .address{
          margin-left:300px;
        }
        .name{
          margin-top: -20px;
        }
       
        .salute1{
          margin-left:-400px
        }
        .description{
         
        }
        .note{
          
        }
        .push{
         margin-left: 20px;
        }
        .submitter{
          padding-left:400px;
        }
          /* Define your CSS styles for the printed content */
        </style>
      </head>
      <body>
      <div class='main'>
      <div class='sub-main'>
      
      <h1>Bosome Freho Rural Bank PLC</h1>
      <h3 class='branch'>${rowData.branch.toUpperCase()}</h3>
      </div>
        <img class='watermark' id="logoImage" src=${Logo} alt='logo'/>
          <div class='address'>
          <section></section>
          <section>
          <p>${rowData.code}</p>
          <p>Date:${moment(rowData.date).format("MM-DD-YYYY")}</p>
          </section>
          </div>
          <p class='salute'>Dear Sir/Madam</p>
          <p class='intro'><span class='push'>We</span> have to advice that your account has been <strong>${
            rowData.status
          }ed </strong> today with the sum of <strong>GHS ${rowData.amount.toLocaleString()}</strong>. <strong>Amount in words:</strong> ${
    rowData.amount_in_words
  }</p>
  
  <p class='description'><strong>Being</strong>:${rowData.description}</p>
  <p class='note'> ${
    rowData.attached_file === "true"
      ? "Which Please Note: This advice has an attached file please refer to the details in it."
      : ""
  }</p>
  </div>
      <p>Yours faithfully</p>
  <div class='approve salute1'>
        <div class='submitter'>
        <p><strong>Approved By</strong></p>
          <p>${rowData.approved_by}</p>
          <p><strong>(${rowData.approvers_position})</strong></p>
        </div>
        <div>
        <p><strong>Sanctioned By</strong></p>
          <p>${rowData.submitted_by}</p>
          <p><strong>(${rowData.submitter_position})</strong></p>
        </div>
  </div>
      </body>
    </html>
  `;

  // Write the HTML content to the new window
  printWindow.document.open();
  printWindow.document.write(content);
  printWindow.document.close();
  // Wait for the image to load before printing
  Promise.all([
    new Promise((resolve, reject) => {
      const logoImage = printWindow.document.getElementById("logoImage");
      logoImage.onload = resolve;
      logoImage.onerror = reject;
    }),
  ]).then(() => {
    printWindow.print();
  });
};

const BranchRow = ({ branch }) => {
  const [open, setOpen] = useState(false);
  const fetchAttachment2 = async (fileName) => {
    let loadingId;

    try {
      // Initialize Firebase Storage
      loadingId = toast.loading("loading...");
      const storage = getStorage();
      const fileRef = ref(storage, `files/${fileName}`);

      // Get the download URL
      const url = await getDownloadURL(fileRef);
      toast.remove(loadingId);

      // Trigger a browser download
      window.open(url, "_blank");
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", fileName); // Set the download attribute with the file name
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    } catch (error) {
      toast.remove(loadingId);
      toast.error(error.message);
    }
  };

  const dispatch = useDispatch();

  const confirm = (id) => {
    dispatch(clearAdvice(id, { responded: "true" }));
  };
  const cancel = () => {
    message.info("Nothing was submitted");
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size='small' onClick={() => setOpen(!open)}>
            {open ? (
              <Tooltip title='click to collapse'>
                <KeyboardArrowUpIcon />
              </Tooltip>
            ) : (
              <Tooltip title='click to view advice'>
                <KeyboardArrowDownIcon />
              </Tooltip>
            )}
          </IconButton>
        </TableCell>
        <TableCell
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <FolderIcon />
          {branch.name}
        </TableCell>
        <TableCell style={{ color: "red" }}>{branch.history.length}</TableCell>
        <TableCell />
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Table size='small' aria-label='nested table'>
              <TableHead>
                <TableRow>
                  <TableCell>code</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Submitted By</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {branch.history.map((historyItem, index) => (
                  <TableRow key={index}>
                    <TableCell>{historyItem.code}</TableCell>
                    <TableCell>{historyItem.status}</TableCell>
                    <TableCell>
                      {moment(historyItem.date).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{historyItem.description}</TableCell>
                    <TableCell>
                      {historyItem?.amount?.toLocaleString()}
                    </TableCell>
                    <TableCell>{historyItem.submitted_by}</TableCell>
                    <TableCell
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        flexGrow: 1,
                      }}>
                      <Tooltip title='print'>
                        <IconButton
                          onClick={() => handlePrint(historyItem)}
                          size='print'>
                          <PrintIcon />
                        </IconButton>
                      </Tooltip>
                      {historyItem.attached_file === "true" && (
                        <Tooltip title='download attached file'>
                          <IconButton
                            onClick={() =>
                              fetchAttachment2(historyItem.filename)
                            }
                            size='small'>
                            <CloudDownloadIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Popconfirm
                        title='remove advice'
                        description='Proceed removing advice?'
                        okText='Yes'
                        cancelText='No'
                        onCancel={cancel}
                        onConfirm={() => confirm(historyItem._id)}>
                        <Tooltip title='clear'>
                          <IconButton size='clear'>
                            <ClearIcon />
                          </IconButton>
                        </Tooltip>
                      </Popconfirm>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

// Main component
const AdviceHome = () => {
  const headOfficeBranches = useSelector((state) => state.headOfficeAdvice);
  const branchAdvice = useSelector((state) => state.branchAdvice);
  const branches = headOfficeBranches.map((branch) =>
    createData(branch._id, branch.history)
  );
  const branchesAdvice = branchAdvice.map((data) =>
    createBranchData(
      data._id,
      data.code,
      data.status,
      data.date,
      data.description,
      data.amount,
      data.submitted_by,
      data.branch,
      data.submitted_by,
      data.submitter_position,
      data.approved_by,
      data.approvers_position,
      data.amount_in_words,
      data.attached_file,
      data.filename
    )
  );
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const dispatch = useDispatch();

  const confirmBranch = (id) => {
    dispatch(clearBranchAdvice(id, { responded: "true" }));
  };
  const cancelBranch = () => {
    message.info("Nothing was submitted");
  };
  const fetchAttachment = async (fileName) => {
    let loadingId;

    try {
      // Initialize Firebase Storage
      loadingId = toast.loading("loading...");
      const storage = getStorage();
      const fileRef = ref(storage, `files/${fileName}`);

      // Get the download URL
      const url = await getDownloadURL(fileRef);
      toast.remove(loadingId);

      // Trigger a browser download
      window.open(url, "_blank");
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", fileName); // Set the download attribute with the file name
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    } catch (error) {
      toast.remove(loadingId);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <Helmet title='Home | Advice' />
      <Toolbar
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <DashboardIcon />
          Dashboard
        </Box>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <Person2Icon />
          Welcome back, {user.results.firstName}!
        </Box>
      </Toolbar>
      <Divider style={{ marginBottom: "10px" }} />

      <TableContainer component={Paper}>
        {user.results.branch === "head office" ? (
          <Table size='small' aria-label='collapsible table'>
            <TableHead
              style={{ backgroundColor: "#F5AF14", fontWeight: "bold" }}>
              <TableRow>
                <TableCell />
                <TableCell style={{ fontWeight: "bold" }}>
                  Branch Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Number of Advice
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {branches.map((branch, index) => (
                <BranchRow key={index} branch={branch} />
              ))}
            </TableBody>
          </Table>
        ) : (
          <Table size='small' aria-label='nested table'>
            <TableHead>
              <TableRow>
                <TableCell>code</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Submitted By</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branchesAdvice.map((historyItem, index) => (
                <TableRow key={index}>
                  <TableCell>{historyItem.code}</TableCell>
                  <TableCell>{historyItem.status}</TableCell>
                  <TableCell>
                    {moment(historyItem.date).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell>{historyItem.description}</TableCell>
                  <TableCell>{historyItem?.amount?.toLocaleString()}</TableCell>
                  <TableCell>{historyItem.submitted_by}</TableCell>
                  <TableCell
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      flexGrow: 1,
                    }}>
                    <Tooltip title='print'>
                      <IconButton
                        onClick={() => {
                          handlePrint(historyItem);
                        }}
                        size='print'>
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
                    {historyItem.attached_file === "true" && (
                      <Tooltip title='download attached file'>
                        <IconButton
                          onClick={() => fetchAttachment(historyItem.filename)}
                          size='small'>
                          <CloudDownloadIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Popconfirm
                      title='remove advice'
                      description='Proceed removing advice?'
                      okText='Yes'
                      cancelText='No'
                      onCancel={cancelBranch}
                      onConfirm={() => confirmBranch(historyItem.id)}>
                      <Tooltip title='clear'>
                        <IconButton size='clear'>
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                    </Popconfirm>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </div>
  );
};

export default AdviceHome;
